import React, { useState, useEffect, useMemo } from 'react';
import { Button, ResetButton } from '../../components/Atom/Button';
import { notification, Timeline, Modal, Table, Skeleton, Empty } from 'antd';
import { PlusCircleOutlined, MinusCircleOutlined, DownOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import http from 'utils/http';
import './assets/style.css';
import Input from 'components/Atom/Input';
import { useNavigate } from 'react-router-dom';
import { USER_ROLES, Wallets, TIMEZONES } from 'utils/constant';
import { getUsersRole, checkUserPermissions, formatAmount } from 'utils/services';
import ShortenId from 'components/Atom/ShortenId';
import StatusTag from 'components/Atom/StatusTag';
import Select from 'components/Atom/Select';
import { formatInTimeZone } from 'date-fns-tz';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Breadcrumbs } from '../../components/Atom/breadcumbs';
import { CautionIcon } from 'assets/icons';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import LoadingSkeleton from '../../components/Skeleton/index';
import { addDeclineListEntry } from 'api/xShields';
import { getDeclineList } from 'api/xShields';
import { isFeatureEnabled } from 'utils/featureAccess';

const ViewTransection = () => {
  const [customRefundReason, setCustomRefundReason] = useState('');
  const [amount, setAmount] = useState(0);
  const [captureAmount, setCaptureAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const useStores = useSelector((state) => state.company.userStores);
  const [triggerWebhook, setTriggerWebhook] = useState(false);
  const [riskCancelLoading, setRiskCancelLoading] = useState(false);
  const [riskApproveLoading, setRiskApproveLoading] = useState(false);
  const [isCustomRefundReason, setIsCustomReason] = useState(false);
  const [isPartialCapture, setIsPartialCapture] = useState(false);
  const [showDetails, setDetails] = useState(null);
  const [open, setOpen] = useState(false);
  const [openBlockModel, setOpenBlockModel] = useState(false);
  const [openCaptureModal, setOpenCaptureModal] = useState(false);
  const [openVoidModal, setOpenVoidModal] = useState(false);
  const store = useSelector((state) => state?.company?.store);
  const [isValueAdding, setIsValueAdding] = useState(false);
  const [blockValue, setBlockValue] = useState({ type: '', value: '' });
  const navigate = useNavigate();
  const location = useLocation();
  const { isPlatformAccount } = getUsersRole();
  const { id } = useParams();
  const providerData = [
    {
      value: 'Customer Request',
    },
    {
      value: 'Fraudulent Transaction',
    },
    {
      value: 'Defective Product',
    },
    {
      value: 'Other',
    },
  ];
  const captureOption = [
    {
      value: 'Full Amount',
    },
    {
      value: 'Partial Amount',
    },
  ];
  const handleOpen = () => {
    setOpen(!open);
  };
  const handleCaptureModalOpen = () => {
    setOpenCaptureModal(!openCaptureModal);
  };
  const handleVoidModalOpen = () => {
    setOpenVoidModal(!openVoidModal);
  };
  const fetchData = async () => {
    try {
      const params = { ...{ store_id: location?.state?.record?.store_id || store?._id } };
      const response = await getDeclineList(params);
      return response?.data?.data;
    } catch (err) {
      console.log(err);
    }
  };
  const { data: declineList, refetch: refetchDeclineData } = useQuery('decline_lists', () => fetchData(), {
    enabled: false,
    manual: true,
  });
  const fetchTransactionData = async () => {
    try {
      const storeId = location?.state?.record?.store_id || store?._id;
      const transaction_id = id || location?.state?.record?._id;
      const response = await http.get(`/transactions/data/${transaction_id}?store_id=${storeId}`);
      const data = response?.data?.data;
      return data;
    } catch {
      return null;
    }
  };

  const {
    data: record,
    refetch,
    isLoading,
    isFetching,
  } = useQuery(`transaction_${id || location?.state?.record?.product_id}`, fetchTransactionData, {
    enabled: false,
    manual: true,
  });
  useEffect(() => {
    refetch();
    refetchDeclineData();
  }, [store]);

  const getBlockTypeLabel = (type) => {
    const typeMap = {
      card_fingerprints: 'Card Fingerprint',
      ip_addresses: 'IP Address',
      emails: 'Email',
      phone_numbers: 'Phone Number',
    };
    return typeMap[type] || 'Unknown';
  };

  const handleBlock = async () => {
    const storeId = location?.state?.record?.store_id || store?._id;
    const activeTab = getBlockTypeLabel(blockValue?.type);
    setIsValueAdding(true);
    const payload = {
      [blockValue?.type]: blockValue?.value,
    };
    const response = await addDeclineListEntry(storeId, payload, activeTab);
    if (response?.data?.success) {
      setOpenBlockModel(false);
      refetch();
      refetchDeclineData();
    }
    setIsValueAdding(false);
  };

  const refundAccessOfBehalfTransaction = (linkData) => {
    let storeData = null;
    if (useStores?.length === 1) {
      storeData = useStores[0];
    } else {
      storeData = useStores.find((obj) => obj._id?.toString() === linkData?.platformStoreId?._id);
    }
    if (!storeData?.linkedAccounts) return false;
    const filterData = storeData?.linkedAccounts?.find((obj) => obj?.userStoreId?._id === linkData?.merchantStoreId?._id);
    if (filterData?.refundAccess) {
      return true;
    } else {
      return false;
    }
  };

  const declineTypeMap = {
    'IP Address': 'ip_addresses',
    Email: 'emails',
    'Phone Number': 'phone_numbers',
  };

  const getPaymentGatewayLogo = (item) => {
    if (!item?.payment?.gateway) {
      return 'N/A';
    }

    switch (item?.payment?.gateway) {
      case 'bank-alfalah':
      case 'test-bank-alfalah':
      case 'xstak-pay':
        return <img src='https://js.xstak.com/images/bank-alfalah.png' alt='bank-alfalah' />;
      case 'checkout':
        return <img src='https://js.xstak.com/images/checkout.svg' width={100} alt='checkout' />;
      case 'mcb':
        return <img src='https://js.xstak.com/images/MCB.png' width={50} alt='mcb' />;
      case 'hbl-cybersource':
      case 'hbl-cybersource-test':
        return <img src='https://js.xstak.com/images/hbl.png' width={50} alt='hbl-cybersource' />;
      case 'pay-fast':
        return <img src='https://js.xstak.com/images/pay-fast.png' width={75} alt='pay-fast' />;
      case 'safepay-cybersource':
        return <img src='https://js.xstak.com/images/safepay.svg' width={60} alt='safepay-cybersource' />;
      case 'jazzcash-wallet':
        return <img src='https://js.xstak.com/images/jazzcashH.svg' width={50} alt='jazzcash-wallet' />;
      case 'meezan-bank':
      case 'meezan-paypro':
        return <img src='https://js.xstak.com/images/meezan-bank.jpeg' width={40} alt='meezan-bank' />;
      case 'easypaisa-wallet':
        return <img src='https://js.xstak.com/images/easypaisa.svg' width={22} alt='easypaisa-wallet' />;
      case 'baadmay':
        return <img src='https://js.xstak.com/images/baadmay.svg' width={100} alt='baadmay' />;
      default:
        return item?.payment?.gateway?.toUpperCase();
    }
  };
  const time_zone = store?.settings?.timezone || TIMEZONES.PKT;
  const structuredData = (item) => {
    const shipping = item?.payment_intent_id?.shipping || null;
    const billing = item?.payment_intent_id?.billingAddress || null;
    const ipAddresses = item?.payment_intent_id?.ip_address || [];
    const blocklist_field = item?.payment_intent_id?.blocklist?.field?.toUpperCase()?.slice(0, -1) || null;
    const customerDetails = [
      { label: 'Customer Name', value: item?.order?.customer?.name || 'N/A' },
      { label: 'Email', value: item?.order?.customer?.email?.toLowerCase()?.includes('@xpay') ? 'N/A' : item?.order?.customer?.email || 'N/A' },
      { label: 'Phone Number', value: item?.order?.customer?.phone || 'N/A' },
    ];
    if (ipAddresses?.length === 0 || ipAddresses?.[0] === null) {
      customerDetails?.push({ label: 'IP Address', value: 'N/A' });
    } else {
      ipAddresses?.forEach((ip, index) => {
        customerDetails?.push({ label: `IP Address ${index + 1}`, value: ip });
      });
    }
    const intent = item?.payment_intent_id;
    const summary = {
      timezone: store?.settings?.timezone || TIMEZONES.PKT,
      customerDetails,
      ...((shipping?.address1 || shipping?.address1) && {
        shippingDetails: [
          {
            label: 'Customer Name',
            value: `${shipping?.firstName || shipping?.first_name || ''} ${shipping?.lastName || shipping?.last_name || ''}`?.trim() || 'N/A',
          },
          { label: 'Phone Number', value: shipping?.phone || 'N/A' },
          {
            label: 'Address 1',
            value: shipping?.address1 || 'N/A',
          },
          {
            label: 'Address 2',
            value: shipping?.address2 || 'N/A',
          },
          {
            label: 'ZIP Code',
            value: shipping?.zip || 'N/A',
          },
          {
            label: 'City',
            value: shipping?.city || 'N/A',
          },
          {
            label: 'Province',
            value: shipping?.province || 'N/A',
          },
          {
            label: 'Country',
            value: shipping?.country || 'N/A',
          },
        ],
      }),
      ...(billing?.address1 && {
        billingDetails: [
          { label: 'Customer Name', value: `${billing?.firstName || ''} ${billing?.lastName || ''}`?.trim() || 'N/A' },
          { label: 'Phone Number', value: billing?.phone || 'N/A' },
          {
            label: 'Address 1',
            value: billing?.address1 || 'N/A',
          },
          {
            label: 'Address 2',
            value: billing?.address2 || 'N/A',
          },
          {
            label: 'ZIP Code',
            value: billing?.zip || 'N/A',
          },
          {
            label: 'City',
            value: billing?.city || 'N/A',
          },
          {
            label: 'Province',
            value: billing?.province || 'N/A',
          },
          {
            label: 'Country',
            value: billing?.country || 'N/A',
          },
        ],
      }),
      transactionDetails: [
        { label: 'Transaction Id', value: item?._id },
        {
          label: 'Payment Status',
          value: item?.payment?.gateway === 'pay-fast' && item?.status?.toUpperCase() === 'OTP_ACTION_REQUIRED' ? <StatusTag tag={'PAYFAST_WEBHOOK_PENDING'} /> : <StatusTag tag={item?.status} />,
        },
        {
          label: 'Payment Link',
          value:
            (item?.payment_intent_id?.metadata?.source || item?.order?.type) === 'custom-payment-shopify' || (item?.payment_intent_id?.metadata?.source || item?.order?.type) === 'custom-payment'
              ? item?.shortURLLinkReference
              : 'N/A',
        },
        { label: 'Intent Id', value: <ShortenId value={item?.payment_intent_id?._id} /> },
        { label: 'Order Source', value: item?.payment_intent_id?.metadata?.source?.toUpperCase() || item?.order?.type?.toUpperCase() },
        {
          label: `Order Amount`,
          value: `${item?.payment?.currency} ${formatAmount(Number(item?.payment?.price || '0') + Number(item?.discount_applied || '0'), item?.payment?.currency)}`,
        },
        { label: 'Subscription Id', value: <ShortenId value={item?.payment_intent_id?.metadata?.subscription_id || 'N/A'} /> },
        ...(item?.payment?.captured_amount
          ? [
              {
                label: `Paid Amount`,
                value: `${item?.payment?.currency} ${formatAmount(Number(item?.payment?.captured_amount), item?.payment?.currency)}`,
              },
            ]
          : []),
        { label: `Refunded Amount`, value: `${item?.payment?.currency} ${formatAmount(item?.refunded_amount, item?.payment?.currency)}` },
        ...(item?.payment_intent_id?.payment_method_types
          ? [{ label: 'Payment Method Type', value: item?.payment_intent_id?.payment_method_types ?? 'N/A' }]
          : [{ label: 'Payment Method Type', value: item?.payment?.gateway == 'nift' ? 'Bank' : 'Card' }]),
        ...(item?.order?.type?.toUpperCase() === 'HEADLESS' && item?.payment_intent_id?.last_payment_response
          ? [
              { label: 'Payment Response Status', value: item?.payment_intent_id?.last_payment_response?.status },
              {
                label: 'Payment Response Message',
                value: (() => {
                  const message = item?.payment_intent_id?.last_payment_response?.message ?? 'N/A';
                  const ownership = item?.payment_intent_id?.ownership;
                  const capturedLikeStatuses = ['CAPTURED', 'PARTIALLY_REFUNDED', 'REFUNDED', 'AUTHORIZED'];
                  const isNotCaptured = !capturedLikeStatuses.includes(item?.status?.toUpperCase?.());
                  const showTag = isNotCaptured && ownership;
                  if (!showTag) return message;
                  return (
                    <span>
                      <span style={{ marginRight: '8px' }}>{message}</span>
                      <StatusTag tag={ownership?.replace(/_/g, ' ')} />
                    </span>
                  );
                })(),
              },
              { label: 'Payment Response Code', value: item?.payment_intent_id?.last_payment_response?.code || 'N/A' },
            ]
          : []),
        {
          label: 'Gateway',
          value: getPaymentGatewayLogo(item),
        },
        { label: 'Creation Time', value: item?.createdAt ? formatInTimeZone(item?.createdAt, time_zone, 'MMM d, yyyy h:mm:ss a') : '-' },
        { label: 'Last Update Time', value: item?.updatedAt ? formatInTimeZone(item?.updatedAt, time_zone, 'MMM d, yyyy h:mm:ss a') : '-' },
        ...(item?.linkedAccountReference?.merchant_id && item?.isBehalfTransaction
          ? [
              { label: isPlatformAccount ? 'Merchant Id' : 'Initiator Id', value: isPlatformAccount ? (item?.linkedAccountReference?.merchant_id ?? 'N/A') : (item?.user_id ?? 'N/A') },
              {
                label: isPlatformAccount ? 'Merchant Store Name' : 'Initiator Store Name',
                value: isPlatformAccount
                  ? (item?.linkedAccountReference?.merchantStoreId?.name ?? item?.linkedAccountReference?.merchantStoreId?.domain ?? 'N/A')
                  : (item?.linkedAccountReference?.platformStoreId?.name ?? item?.linkedAccountReference?.platformStoreId?.domain ?? 'N/A'),
              },
            ]
          : []),
        ...(item?.payment?.gateway === 'bank-alfalah' ? [{ label: 'Risk Score', value: item?.order?.order_risk_score >= 0 ? item?.order?.order_risk_score : 'N/A' }] : []),
        { label: 'Card Fingerprint', value: <ShortenId value={item?.payment_intent_id?.hashed_card_number || 'N/A'} /> },
        ...(item?.payment_ids?.length > 0 ? [{ label: 'Previously Failed Payment IDs', value: item?.payment_ids?.join(', ') || 'N/A' }] : []),
        ...(item?.payment_intent_id?.blocklist
          ? [
              {
                label: 'Block List Reason',
                value: (
                  <>
                    <strong>{blocklist_field}</strong>:&nbsp; <ShortenId value={item?.payment_intent_id?.blocklist?.value || 'N/A'} />
                  </>
                ),
              },
            ]
          : []),
      ],
      ...(intent?.apply_bin_discount &&
        intent?.amount_summary &&
        intent?.amount_summary != undefined &&
        Object.keys(intent?.amount_summary).length > 0 && {
          binDiscountDetails: [
            {
              label: `Base Amount`,
              value: `${item?.payment?.currency} ${formatAmount(intent?.original_amount, item?.currency)}`,
            },
            {
              label: `Discount`,
              value: `${formatAmount(intent?.applied_bin_discount_details?.value, item?.payment?.currency)} ${intent?.applied_bin_discount_details?.type === 'percentage' ? '%' : ''}`,
            },
            {
              label: `Discount Capped`,
              value: `${formatAmount(intent?.applied_bin_discount_details?.limit, item?.payment?.currency)}`,
            },
            {
              label: `Discounted Amount`,
              value: `${item?.payment?.currency} ${formatAmount(intent?.discount_applied, item?.payment?.currency)}`,
            },
            {
              label: `Tax Type`,
              value: intent?.tax_info?.type ? <StatusTag tag={intent?.tax_info?.type?.toUpperCase()} {...(intent?.tax_info?.type === 'exclusive' && { color: 'orange' })} /> : 'N/A',
            },
            {
              label: `Tax Rate`,
              value: `${formatAmount(intent?.tax_info?.rate)}%`,
            },
            {
              label: `Tax Amount`,
              value: `${item?.payment?.currency} ${formatAmount(intent?.amount_summary?.tax_amount)}`,
            },
            {
              label: `Additional Charges`,
              value: intent?.tax_info?.type === 'exclusive' ? `${item?.payment?.currency} ${formatAmount(intent?.amount_summary?.additional_charges)}` : 'N/A',
            },
            {
              label: `Total After Discount`,
              value: `${item?.payment?.currency} ${formatAmount(intent?.amount_summary?.total_after_discount)}`,
            },
          ],
        }),
    };
    const transaction_details = {
      status: item?.status,
      currencySymbol: item?.payment?.currency,
      store_id: item?.store_id,
      refunded_amount: item?.refunded_amount,
      orderPrice: item?.payment?.captured_amount || item?.payment?.price,
      gatewayType: item?.payment?.gateway,
      paymentId: item?.payment?.id,
      payment_response: item?.payment_intent_id?.last_payment_response?.status,
      paymentResponse: item?.order?.type?.toUpperCase() === 'HEADLESS' && item?.payment_intent_id?.last_payment_response,
      payment_message: item?.payment_intent_id?.last_payment_response?.message,
      orderId: item?.order?.type?.toUpperCase() === 'HEADLESS' ? (item?.payment_intent_id?.metadata?.order_name ?? item?.payment_intent_id?.metadata?.order_reference ?? 'N/A') : item?.order?.name,
      orderType: item?.payment_intent_id?.metadata?.source || item?.order?.type,
      reference: item?.order?.id,
      createtime: item?.createdAt,
      updatetime: item?.updatedAt,
      id: item?._id,
      user_id: item?.user_id,
      sessionId: item?.shortURLLinkReference,
      refundAccess: item?.isBehalfTransaction && isPlatformAccount ? refundAccessOfBehalfTransaction(item?.linkedAccountReference) : true,
      activity: item?.activity,
      card_detail: item?.payment_intent_id?.card_detail || null,
      ...(item?.isBehalfTransaction &&
        item?.linkedAccountReference?.merchant_id && {
          isBehalfTransaction: item?.isBehalfTransaction,
          linkedAccountReference: item?.linkedAccountReference,
        }),
      userActivity: item?.session_id?.userActivity,
      payment_method: item?.payment_intent_id?.payment_method_types?.toUpperCase(),
    };
    return { transaction_details, summary };
  };
  const { transaction_details: refundData, summary: data } = structuredData(record);

  const routingRulesHistoryRows = useMemo(() => {
    const history = record?.payment_intent_id?.routing_rules_history ?? [];
    const storeId = refundData?.store_id;
    const matchedStore = useStores?.find((s) => s?._id?.toString() === storeId?.toString());
    const rulesById = new Map((matchedStore?.payment_routing_rules ?? []).map((rule) => [rule?._id?.toString(), rule]));

    return history.map((item) => {
      const storeRule = rulesById.get(item?.rule_id?.toString());
      return {
        ...item,
        ruleName: storeRule?.name ?? '-',
        ruleStatus: storeRule ? (storeRule?.enabled ? 'Active' : 'Inactive') : 'Deleted',
      };
    });
  }, [record?.payment_intent_id?.routing_rules_history, refundData?.store_id, useStores]);

  const refundTransaction = async (item) => {
    setLoading(true);
    if (amount <= 0 || amount === '') {
      notification.error({ message: 'Please enter refund amount', placement: 'bottomRight' });
      setLoading(false);
    } else if (!isCustomRefundReason && customRefundReason === '') {
      notification.error({ message: 'Please select refund reason', placement: 'bottomRight' });
      setLoading(false);
    } else if ((customRefundReason === '' || customRefundReason === null || customRefundReason === 'Other') && isCustomRefundReason) {
      notification.error({ message: 'Please enter custom refund reason', placement: 'bottomRight' });
      setLoading(false);
    } else {
      try {
        let refundPayload;
        if (refundData?.linkedAccountReference?.merchant_id && refundData?.isBehalfTransaction) {
          refundPayload = {
            amount: String(amount),
            isBehalfTransaction: true,
            refundReason: customRefundReason,
            merchantStoreId: item?.linkedAccountReference?.merchantStoreId?._id,
            merchantUserId: refundData?.linkedAccountReference?.merchant_id,
          };
        } else {
          refundPayload = { amount: String(amount), refundReason: customRefundReason, isBehalfTransaction: false };
        }
        await http.post(`/transactions/refund/${refundData?.store_id}/${refundData?.id}`, refundPayload);
        notification.success({ message: 'REFUND SUCCESSFUL', placement: 'bottomRight' });
        setOpen(false);
        navigate('/transactions');
      } catch (err) {
        notification.error({ message: err?.response?.data?.message?.message || err?.response?.data?.message || 'Something went Wrong', placement: 'bottomRight' });
      }
      setAmount(0);
      setLoading(false);
    }
  };

  const capturePayment = async () => {
    setLoading(true);
    if (isPartialCapture && (captureAmount <= 0 || captureAmount === '')) {
      notification.error({ message: 'Please enter amount', placement: 'bottomRight' });
      setLoading(false);
    } else if (isPartialCapture && captureAmount > refundData?.orderPrice) {
      notification.error({ message: 'Capture amount must be less than or equal to order amount', placement: 'bottomRight' });
      setLoading(false);
    } else {
      try {
        let payload;
        if (!isPartialCapture) {
          payload = {};
        } else {
          payload = {
            amount: captureAmount,
          };
        }
        await http.post(`public/v1/payment/intent/capture?pi_client_secret=${record?.payment_intent_id?.pi_client_secret}&store_id=${record?.store_id}`, payload);
        notification.success({ message: 'Capture successfully', placement: 'bottomRight' });
        setOpenCaptureModal(false);
        navigate('/transactions');
      } catch (err) {
        notification.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
      }
      setCaptureAmount(0);
      setLoading(false);
    }
  };

  const voidPayment = async () => {
    setLoading(true);
    try {
      await http.post(`public/v1/payment/intent/void?pi_client_secret=${record?.payment_intent_id?.pi_client_secret}&store_id=${record?.store_id}`);
      notification.success({ message: 'Payment successfully voided', placement: 'bottomRight' });
      setOpenVoidModal(false);
      navigate('/transactions');
    } catch (err) {
      notification.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
    }
    setLoading(false);
  };

  const handleRefundReason = (e) => {
    setCustomRefundReason(e.value);
    if (e.value === 'Other') {
      setIsCustomReason(true);
    } else {
      setIsCustomReason(false);
    }
  };

  const handleCaptureType = (e) => {
    if (e?.value === 'Partial Amount') {
      setIsPartialCapture(true);
    } else {
      setIsPartialCapture(false);
    }
  };

  const breadcrumbProps = {
    breadcrumbs: [
      {
        name: 'XPay',
        href: '/xpay',
      },
      {
        name: 'Transaction',
        href: '/transactions',
        data: { id: location?.state?.id, isRedirection: true, filtersData: location?.state?.filtersData, searchValue: location?.state?.searchValue },
      },
      {
        name: <ShortenId value={id || location?.state?.id || 'Not Found'} />,
      },
    ],
  };

  const handleRiskTransaction = async (status) => {
    if (status == 'reject') {
      setRiskCancelLoading(true);
    } else {
      setRiskApproveLoading(true);
    }
    try {
      await http.post(`/transactions/updateStatus/${refundData?.store_id}/${refundData?.id}`, { data: refundData, status: status });
      refetch();
      notification.success({ message: 'TRANSACTION STATUS UPDATED', placement: 'bottomRight' });
    } catch (err) {
      notification.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
    }
    if (status == 'reject') {
      setRiskCancelLoading(false);
    } else {
      setRiskApproveLoading(false);
    }
  };

  const replicateOrder = async (order_id, store_id) => {
    try {
      setLoading(true);
      navigate('/paymentlink', { state: { order_id, store_id } });
    } catch (err) {
      setLoading(false);
      console.log(err?.response);
      notification.error({ message: err?.response?.data?.message, placement: 'bottomRight' });
    }
  };
  const onClickHandle = (key, value) => {
    setDetails((pre) => ({ ...pre, [key]: value }));
  };
  const assignOrderStatusColor = (text) => {
    const e = text?.toUpperCase();
    if (e === 'TIMEOUT' || e === 'CANCELLED' || e === 'DRAFT' || e === 'OTP_ACTION_REQUIRED') {
      return 'yellow';
    } else if (
      e === 'FAILED' ||
      e === 'AUTHENTICATION_NOT_SUPPORTED' ||
      e === 'AUTHENTICATION_FAILED' ||
      e === 'AUTHORIZATION_DECLINED' ||
      e === 'AUTHENTICATION_REJECTED' ||
      e === 'AUTHORIZATION_REJECTED' ||
      e === 'AUTHORIZATION_FAILED' ||
      e === 'AUTHENTICATION_UNAVAILABLE' ||
      e === 'AUTHORIZED_RISK_DECLINED'
    ) {
      return 'red';
    } else if (e === 'AUTHENTICATION_PENDING' || e === 'PENDING') {
      return 'gray';
    } else if (e === 'REFUNDED' || e === 'PARTIALLY_REFUNDED') {
      return 'blue';
    } else {
      return 'green';
    }
  };
  let cardDetails = null;
  const excludedStatuses = ['PENDING', 'OTP_ACTION_REQUIRED', 'DRAFT'];
  if (refundData?.activity?.length > 0 && !excludedStatuses?.includes(refundData?.status?.toUpperCase())) {
    const capturePaymentData = refundData?.activity?.find((obj) => obj?.status === 'CAPTURED');
    if (capturePaymentData) {
      cardDetails = capturePaymentData;
    } else {
      for (let i = refundData?.activity?.length - 1; i >= 0; i--) {
        const cardData = refundData?.activity[i];
        if (cardData?.card?.number || cardData?.card_number || cardData?.wallet?.phone) {
          cardDetails = cardData;
          break;
        }
      }
    }
  } else if (refundData?.card_detail) {
    cardDetails = refundData?.card_detail;
  }
  const handleRefundAmount = (value) => {
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setAmount(value);
    }
  };
  const handleCaptureAmount = (value) => {
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setCaptureAmount(value);
    }
  };
  const handleWebhookTrigger = async () => {
    setTriggerWebhook(true);
    try {
      await http.post(`/transactions/trigger/webhook/${refundData?.store_id}/${refundData?.id}`);
      notification.success({ message: 'WEBHOOK TRIGGERED SUCCESSFULLY', placement: 'bottomRight' });
      //  navigate('/transactions');
    } catch (err) {
      console.log(err?.response);
      notification.error({ message: err?.response?.data?.message ?? 'SOMETHING WENT WRONG', placement: 'bottomRight' });
    }
    setTriggerWebhook(false);
  };
  const cardInfoData = (cardDetails) => {
    const cardInfo = [
      ...(refundData?.gatewayType === Wallets?.JAZZ_CASH || refundData?.gatewayType === Wallets?.EASY_PAISA
        ? [
            { label: 'CNIC', value: cardDetails?.wallet?.cnic ?? 'N/A' },
            { label: 'Phone', value: cardDetails?.wallet?.phone ?? 'N/A' },
            { label: 'Authorization Code', value: cardDetails?.authorizationCode ?? 'N/A' },
            { label: 'Message', value: cardDetails?.wallet?.message ?? 'N/A' },
            { label: 'Status Code', value: cardDetails?.wallet?.statusCode ?? 'N/A' },
          ]
        : [
            { label: 'Name', value: cardDetails?.card?.name || cardDetails?.nameOnCard || 'N/A' },
            { label: 'Card Number', value: cardDetails?.card?.number || cardDetails?.card_number || 'N/A' },
            { label: 'Funding Method', value: cardDetails?.card?.funding_method?.toUpperCase() ?? 'N/A' },
            {
              label: 'Card Type',
              value:
                cardDetails?.card?.type?.toUpperCase() === 'VISA' || cardDetails?.bin?.card_type?.toUpperCase() === 'VISA' ? (
                  <img src='https://js.xstak.com/images/visa.svg' width={40} alt='VISA' />
                ) : cardDetails?.card?.type?.toUpperCase() === 'MASTERCARD' || cardDetails?.bin?.card_type?.toUpperCase() === 'MASTERCARD' ? (
                  <img src='https://js.xstak.com/images/mastercard.svg' width={40} alt='MASTERCARD' />
                ) : cardDetails?.card?.type?.toUpperCase() === 'AMEX' || cardDetails?.bin?.card_type?.toUpperCase() === 'AMEX' ? (
                  <img src='https://js.xstak.com/images/amex.svg' width={40} alt='AMEX' />
                ) : (
                  cardDetails?.card?.type?.toUpperCase() || cardDetails?.bin?.card_type?.toUpperCase() || 'N/A'
                ),
            },
            { label: 'Authorization Code', value: cardDetails?.authorizationCode ? cardDetails?.authorizationCode : 'N/A' },
            { label: 'Card Version', value: cardDetails?.secure?.toUpperCase() ?? 'N/A' },
            { label: 'Card Issuer', value: cardDetails?.issuerDetails?.card_issuer || cardDetails?.bin?.card_issuer || 'N/A' },
            {
              label: 'Card Network',
              value:
                cardDetails?.issuerDetails?.card_network?.toUpperCase() === 'VISA' || cardDetails?.bin?.card_network?.toUpperCase() === 'VISA' ? (
                  <img src='https://js.xstak.com/images/visa.svg' width={40} alt='VISA' />
                ) : cardDetails?.issuerDetails?.card_network?.toUpperCase() === 'MASTERCARD' || cardDetails?.bin?.card_network?.toUpperCase() === 'MASTERCARD' ? (
                  <img src='https://js.xstak.com/images/mastercard.svg' width={40} alt='MASTERCARD' />
                ) : cardDetails?.issuerDetails?.card_network?.toUpperCase() === 'AMEX' || cardDetails?.bin?.card_network?.toUpperCase() === 'AMEX' ? (
                  <img src='https://js.xstak.com/images/amex.svg' width={40} alt='AMEX' />
                ) : cardDetails?.issuerDetails?.card_network?.toUpperCase() === 'PAYPAK' || cardDetails?.bin?.card_network?.toUpperCase() === 'PAYPAK' ? (
                  <img src='https://js.xstak.com/images/paypak.png' width={40} alt='PAYPAK' />
                ) : (
                  cardDetails?.issuerDetails?.card_network || cardDetails?.bin?.card_network || 'N/A'
                ),
            },
            { label: 'Amount', value: formatAmount(cardDetails?.amount, refundData?.currencySymbol) ?? 'N/A' },
          ]),
      ...(refundData?.gatewayType === 'hbl-cybersource'
        ? [
            { label: 'ECI', value: cardDetails?.eci?.toUpperCase() ?? 'N/A' },
            { label: 'CAVV', value: cardDetails?.cavv?.toUpperCase() ?? 'N/A' },
            { label: 'XID', value: cardDetails?.xid?.toUpperCase() ?? 'N/A' },
            { label: 'AVS Code', value: cardDetails?.avsCode?.toUpperCase() ?? 'N/A' },
            { label: 'Reference Number', value: cardDetails?.retrievalReferenceNumber?.toUpperCase() ?? 'N/A' },
            { label: 'Acquirer Transaction Id', value: cardDetails?.acquirerTransactionId?.toUpperCase() ?? 'N/A' },
          ]
        : []),
      ...(refundData?.gatewayType !== 'hbl-cybersource' && refundData?.gatewayType !== Wallets?.JAZZ_CASH && refundData?.gatewayType !== Wallets.EASY_PAISA
        ? [{ label: 'Terminal Id', value: cardDetails?.terminal ?? 'N/A' }]
        : []),
    ];
    return cardInfo;
  };

  const generalInfo = [
    { label: 'Amount', value: `${refundData?.currencySymbol} ${formatAmount(refundData?.orderPrice, refundData?.currencySymbol)}` ?? 'N/A' },
    { label: 'Payment ID', value: refundData?.paymentId ?? 'N/A' },
    { label: 'Order ID', value: refundData?.orderId ?? 'N/A' },
  ];

  const refundInfo = [
    { label: 'Order ID', value: refundData?.orderId ?? 'N/A' },
    { label: 'Paid Amount', value: formatAmount(refundData?.orderPrice, refundData?.currencySymbol) ?? 'N/A' },
    { label: 'Refunded Amount', value: formatAmount(refundData?.refunded_amount, refundData?.currencySymbol) ?? 'N/A' },
    { label: 'Currency', value: refundData?.currencySymbol ?? 'N/A' },
  ];
  const routingRulesHistoryColumns = [
    {
      title: 'Rule Id',
      render: (value) => value?.rule_id,
      key: 'rule_id',
    },
    {
      title: 'Name',
      render: (value) => value?.ruleName ?? '-',
      key: 'ruleName',
    },
    {
      title: 'Gateway Id',
      render: (value) => value?.instance_id,
      key: 'instance_id',
    },
    {
      title: 'Gateway',
      render: (value) => getPaymentGatewayLogo({ payment: { gateway: value?.gateway } }),
      key: 'gateway',
    },
    {
      title: 'Status',
      render: (value) => <StatusTag tag={value?.ruleStatus} />,
      key: 'ruleStatus',
    },
  ];
  const gatewayAttemptHistoryColumns = [
    {
      title: 'Gateway Id',
      render: (value) => value?.instance_id,
      key: 'instance_id',
    },
    {
      title: 'Gateway',
      render: (value) => getPaymentGatewayLogo({ payment: { gateway: value?.gateway } }),
      key: 'gateway',
    },
  ];

  const fraudJobDetails = [
    {
      title: 'Rule Id',
      render: (value) => value?.rule_id ?? '-',
      key: 'rule_id',
    },
    {
      title: 'Rule Name',
      render: (value) => value?.name ?? '-',
      key: 'rule_name',
    },
    {
      title: 'Rule',
      render: (value) => (value?.fullRule ? <ShortenId value={value?.fullRule} /> : '-'),
      key: 'full_rule',
    },
    {
      title: 'Blocked Transaction',
      render: (value) => (value?.didBlockTransaction ? 'Yes' : 'No'),
      key: 'rule_block',
    },
  ];

  return (
    <div>
      <div className='header-container p-4 custom-sticky'>
        <div className='transaction-breadcrums' style={{ display: 'flex', gap: '16px', marginBottom: '15px', alignItems: 'center' }}>
          <div
            className='back-button'
            onClick={() =>
              navigate('/transactions', {
                state: {
                  id: location?.state?.id,
                  isRedirection: true,
                  filtersData: location?.state?.filtersData,
                  searchValue: location?.state?.searchValue,
                },
              })
            }>
            <ArrowLeftOutlined /> <span style={{ fontWeight: 600 }}>Back</span>
          </div>
          <span style={{ color: '#8C8C8C' }}>|</span>
          <Breadcrumbs {...breadcrumbProps} />
          <ResetButton onClick={refetch} loading={isFetching} />
        </div>
        <div className='detail-heading mb-4'>Transaction Detail</div>
        <div className='headerPage' style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
          <div className='payment-message' style={{ display: 'flex' }}>
            {isLoading ? (
              <Skeleton.Input className='status-skeleton' />
            ) : (
              refundData?.status && (
                <div className='header-tag'>
                  {refundData?.gatewayType === 'pay-fast' && refundData?.status?.toUpperCase() === 'OTP_ACTION_REQUIRED' ? (
                    <StatusTag tag={'PAYFAST_WEBHOOK_PENDING'} />
                  ) : (
                    <StatusTag tag={refundData?.status} /> || 'N/A'
                  )}
                </div>
              )
            )}
            {isLoading ? (
              <Skeleton.Input className='message-skeleton' />
            ) : (
              refundData?.paymentResponse && (
                <div style={{ width: '100%' }}>
                  <div className='message' style={{ padding: '6.2px 12px', marginLeft: '6px', borderRadius: '8px' }}>
                    {refundData?.payment_message}
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
      <div className='breakWord'>
        <div className='transaction-details'>
          {isLoading ? (
            <LoadingSkeleton />
          ) : !record ? (
            store?.isSelected ? (
              <div className='empty-custom-style'>
                <Empty image={Empty?.PRESENTED_IMAGE_SIMPLE} />
              </div>
            ) : (
              <div className='empty-custom-style'>
                <Empty description={'Select store from the drop-down menu above'} />
              </div>
            )
          ) : (
            <>
              <div className='general-Details details-section'>
                <div className='detail-card'>
                  {generalInfo?.map((info, index) => (
                    <div key={index} className='detail-value'>
                      <h2 style={{ fontWeight: '600' }}>{info?.label}</h2> <span>{info?.value || 'N/A'}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className='Payment-Details details-section'>
                <div className='heading-section'>
                  <h3>Payment Details</h3>
                </div>
                <div className='detail-card'>
                  {data?.transactionDetails?.map((info, index) => {
                    const isBlocked = declineList?.decline_lists?.card_fingerprints?.some((item) => item?.value === info?.value?.props?.value);
                    return (
                      <div key={index} className='detail-value'>
                        <h2>{info?.label}</h2>
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                          {info?.value}
                          {info?.label?.includes('Card Fingerprint') && info?.value?.props?.value !== 'N/A' && (
                            <Button
                              className='secondary-btn ml-4 block-ip'
                              onClick={() => {
                                if (!isBlocked) {
                                  setOpenBlockModel(true);
                                  setBlockValue({ type: 'card_fingerprints', value: info?.value?.props?.value });
                                }
                              }}
                              disabled={isBlocked}>
                              {isBlocked ? 'Blocked' : 'Click to Block'}
                            </Button>
                          )}
                        </span>
                      </div>
                    );
                  })}
                </div>
                {refundData?.linkedAccountReference?.merchant_id && refundData?.isBehalfTransaction && (
                  <div className='p-3 bg-white' style={{ width: '100%' }}>
                    <div className='bg-[#FFFBE6] gap-3 p-3 rounded-lg flex border border-[#FFE58F]'>
                      <div className='mt-[2px]'>
                        <CautionIcon />
                      </div>
                      <div> {isPlatformAccount ? 'This transaction is done on behalf of above mentioned merchant account.' : 'This transaction is done by above mentioned initiator account.'}</div>
                    </div>
                  </div>
                )}
              </div>
              {data?.binDiscountDetails?.length > 0 && (
                <div className='Payment-Details details-section'>
                  <div className='heading-section'>
                    <h3>Bin Discount Details</h3>
                  </div>
                  <div className='detail-card'>
                    {data?.binDiscountDetails?.map((info, index) => {
                      return (
                        <div key={index} className='detail-value'>
                          <h2>{info?.label}</h2>
                          <span style={{ display: 'flex', alignItems: 'center' }}>{info?.value}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {record?.job_id?.rules && (
                <div className='details-section '>
                  <div className='heading-section'>
                    <h3>Fraud Job Details</h3>
                  </div>
                  <div className='table-container'>
                    <Table columns={fraudJobDetails} dataSource={record?.job_id?.rules} pagination={false} />
                  </div>
                </div>
              )}
              <div className='Customer-Details details-section'>
                <div className='heading-section'>
                  <h3>Customer Details</h3>
                </div>

                <div className='detail-card'>
                  {data?.customerDetails?.map((info, index) => {
                    const matchedType = Object.entries(declineTypeMap)?.find(([labelKeyword]) => info?.label?.includes(labelKeyword));
                    const declineType = matchedType?.[1];
                    const isBlocked = declineType ? declineList?.decline_lists?.[declineType]?.some((item) => item?.value === info?.value) : false;
                    return (
                      <div key={index} className='detail-value'>
                        <h2>{info?.label}</h2>
                        <span style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          {info?.value}
                          {declineType && info?.value !== 'N/A' && info?.value !== null && (
                            <Button
                              className='secondary-btn ml-4 block-ip'
                              onClick={() => {
                                if (!isBlocked) {
                                  setOpenBlockModel(true);
                                  setBlockValue({ type: declineType, value: info?.value });
                                }
                              }}
                              disabled={isBlocked}>
                              {isBlocked ? 'Blocked' : 'Click to Block'}
                            </Button>
                          )}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
              {data?.shippingDetails && (
                <div className='Shipping-Details details-section'>
                  <div className='heading-section'>
                    <h3>Shipping Details</h3>
                  </div>
                  <div className='detail-card'>
                    {data?.shippingDetails?.map((info, index) => (
                      <div key={index} className='detail-value'>
                        <h2>{info?.label}</h2> <span>{info?.value || 'N/A'}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {data?.billingDetails && (
                <div className='Billing-Details details-section'>
                  <div className='heading-section'>
                    <h3>Billing Details</h3>
                  </div>
                  <div className='detail-card'>
                    {data?.billingDetails?.map((info, index) => (
                      <div key={index} className='detail-value'>
                        <h2>{info?.label}</h2> <span>{info?.value || 'N/A'}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {cardDetails && (
                <div className='Card-details details-section'>
                  <div className='heading-section'>
                    <h3>{refundData?.gatewayType === Wallets?.JAZZ_CASH || refundData?.gatewayType === Wallets.EASY_PAISA ? 'Wallet details' : 'Card details'}</h3>
                  </div>
                  <div className='detail-card'>
                    {cardInfoData(cardDetails)?.map((info, index) => (
                      <div key={index} className='detail-value'>
                        <h2>{info?.label}</h2> <span>{info?.value || 'N/A'}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {refundData?.activity?.length > 0 && (
                <div className='Timeline details-section' style={{ paddingBottom: '8px' }}>
                  <div className='heading-section'>
                    <h3>Timeline</h3>
                  </div>
                  <Timeline style={{ marginTop: '6px', padding: '20px', paddingBottom: '0' }}>
                    {refundData?.activity?.map((obj, index) => {
                      return (
                        obj?.status && (
                          <Timeline.Item color={assignOrderStatusColor(obj?.status === 'AUTHORIZED_DECLINED' ? 'AUTHORIZATION_DECLINED' : obj?.status)} key={index}>
                            <p className='font-semibold detailBtn'>
                              <span style={{ marginTop: '2px' }}>{obj?.status === 'AUTHORIZED_DECLINED' ? 'AUTHORIZATION_DECLINED' : (obj?.status ?? '')}</span>
                              {obj?.status !== 'PARTIALLY_REFUNDED' &&
                                obj?.status !== 'REFUNDED' &&
                                obj?.status !== 'PENDING' &&
                                obj?.status !== 'FAILED' &&
                                obj?.status !== 'DRAFT' &&
                                obj?.status !== 'OTP_ACTION_REQUIRED' &&
                                obj?.status !== 'TIMEOUT' && (
                                  <>
                                    {Object.keys(showDetails ?? {})?.length > 0 && showDetails[index] == index ? (
                                      <MinusCircleOutlined style={{ fontSize: '15px', marginLeft: '1.5%', color: '#7e62d1' }} onClick={() => onClickHandle(index, null)} />
                                    ) : (
                                      <PlusCircleOutlined style={{ fontSize: '15px', marginLeft: '1.5%', color: '#7e62d1' }} onClick={() => onClickHandle(index, index)} />
                                    )}
                                  </>
                                )}
                            </p>
                            {Object.keys(showDetails ?? {})?.length > 0 && showDetails[index] === index ? (
                              <div className='detail-card' style={{ padding: '0' }}>
                                {cardInfoData(obj)?.map((info, index) => (
                                  <div key={index} className='detail-value'>
                                    <h2>{info?.label}</h2> <span>{info?.value || 'N/A'}</span>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <>
                                <p style={{ margin: '3px 0px', fontSize: '14px' }}>
                                  {obj?.timestamp || obj?.createdAt ? formatInTimeZone(obj?.timestamp || obj?.createdAt, data?.timezone, 'MMM d, yyyy h:mm:ss a') : ''}
                                </p>
                                {(obj?.status === 'PARTIALLY_REFUNDED' || obj?.status === 'REFUNDED') && obj?.refundReason && (
                                  <>
                                    {obj?.refundReason && (
                                      <p style={{ margin: '3px 0px', fontSize: '13px' }}>
                                        <b>Reason: </b>
                                        {obj?.refundReason}
                                      </p>
                                    )}
                                    {obj?.refund_initiator_id && (
                                      <p style={{ margin: '3px 0px', fontSize: '13px' }}>
                                        <b>Initiator: </b>
                                        {obj?.refund_initiator_id}
                                      </p>
                                    )}
                                  </>
                                )}
                              </>
                            )}
                          </Timeline.Item>
                        )
                      );
                    })}
                  </Timeline>
                </div>
              )}
              {(refundData?.status === 'CAPTURED' || refundData?.status === 'PARTIALLY_CAPTURED' || refundData?.status === 'PARTIALLY_REFUNDED') &&
                refundData?.refundAccess &&
                checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_REFUND]) &&
                refundData?.orderType !== 'shopify-public-app' &&
                refundData?.orderType !== 'shopify-cc-app' && (
                  <div className='Refund-Payment details-section'>
                    <div className='heading-section'>
                      <h3>Refund Payment</h3>
                    </div>

                    <div className='detail-card'>
                      {refundInfo?.map((info, index) => (
                        <div key={index} className='detail-value'>
                          <h2>{info?.label}</h2> <span>{info?.value || 'N/A'}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              {refundData?.userActivity?.length > 0 && (
                <div className='User-Activities details-section'>
                  <div className='heading-section'>
                    <h3>User Activities</h3>
                  </div>
                  <Timeline style={{ marginTop: '6px', padding: '20px' }}>
                    {refundData?.userActivity?.map((obj, index) => {
                      return (
                        <Timeline.Item color='green' key={index}>
                          <p style={{ fontWeight: '600', fontSize: '15px' }}>{obj?.activity}</p>
                          <p style={{ marginTop: '-5px', fontSize: '13px' }}>{obj?.time ? formatInTimeZone(obj?.time, data?.timezone, 'MMM d, yyyy h:mm:ss a') : ''}</p>
                        </Timeline.Item>
                      );
                    })}
                  </Timeline>
                </div>
              )}
              {record?.payment_intent_id?.gateway_retry_attempts_history?.length > 0 && (
                <div className='details-section'>
                  <div className='heading-section'>
                    <h3>Gateway Retry Attempts</h3>
                  </div>
                  <div className='table-container'>
                    <Table className='custom-table-class' columns={gatewayAttemptHistoryColumns} dataSource={record?.payment_intent_id?.gateway_retry_attempts_history} pagination={false} />
                  </div>
                </div>
              )}
              {record?.payment_intent_id?.routing_rules_history?.length > 0 && (
                <div className='details-section'>
                  <div className='heading-section'>
                    <h3>Payment Routing History</h3>
                  </div>
                  <div className='table-container'>
                    <Table
                      className='custom-table-class'
                      columns={routingRulesHistoryColumns}
                      rowKey={(row, index) => row?.rule_id ?? index}
                      onRow={(data) => {
                        return {
                          onClick: () => {
                            if (data?.ruleStatus === 'Deleted') return;
                            navigate(`/payment-routing/details`, { state: { record: { ...data, store_id: refundData?.store_id } } });
                          },
                        };
                      }}
                      dataSource={routingRulesHistoryRows}
                      pagination={false}
                    />
                  </div>
                </div>
              )}
            </>
          )}
        </div>

        <Modal trigger='click' open={open} className='refund-modal' width={window?.innerWidth < 768 ? 300 : 400} footer={null} destroyOnClose onCancel={handleOpen}>
          <div className='mobileVersion'>
            <div className='font-semibold text-base'>Refund Amount</div>
            <div className='mb-6'>
              <div className='mt-4 mb-4'>
                <div className=' order-solid' style={{ marginTop: '10px', marginBottom: '16px' }}>
                  <p className='font-medium mb-1'>Refund Amount</p>
                  <Input
                    type='number'
                    value={amount !== 0 ? amount : ''}
                    onChange={(e) => handleRefundAmount(e?.target?.value)}
                    min={0}
                    placeholder={`Enter Refund Amount in (${refundData?.currencySymbol ?? ''})`}
                    style={{ height: '40px' }}
                  />
                </div>
                <div className=' order-solid customSelect' style={{ marginTop: '5px' }}>
                  <p className='font-medium mb-1'>Refund Reason</p>
                  <Select defaultValue={'Select Reason'} handleChange={handleRefundReason} optionsValue={providerData} style={{ width: '100%', borderRadius: '8px' }} />
                </div>
              </div>
              {isCustomRefundReason ? (
                <div>
                  <p className='font-medium mb-1' style={{ margin: '12px 0px 3px 0px' }}>
                    Custom Refund Reason
                  </p>
                  <Input type='text' style={{ height: '40px' }} onChange={(e) => setCustomRefundReason(e?.target?.value)} placeholder={'Enter Custom Refund Reason'} />
                </div>
              ) : null}
            </div>
          </div>
          <div className='flex mt-4 modalButton'>
            <Button
              onClick={() => {
                setOpen(false);
              }}
              block
              className='rounded-lg bg-plain'>
              Cancel
            </Button>
            <Button className='ml-4 primaryBtn rounded-lg' disabled={amount ? false : true} block onClick={refundTransaction} loading={loading}>
              Refund Amount
            </Button>
          </div>
        </Modal>

        <Modal trigger='click' open={openVoidModal} className='capture-modal' width={window?.innerWidth < 768 ? 300 : 400} footer={null} destroyOnClose onCancel={handleVoidModalOpen}>
          <header className='font-semibold text-base mb-2'>Void Payment</header>
          <div className='mb-8'>
            Are you sure you want to Void this Authorized Payment<span>{'?'}</span>
          </div>
          <div className='flex mt-4 modalButton'>
            <Button
              onClick={() => {
                setOpenVoidModal(false);
              }}
              block
              className='rounded-lg bg-plain'>
              Cancel
            </Button>
            <Button className='ml-4 primaryBtn rounded-lg' block onClick={voidPayment} loading={loading}>
              Confirm
            </Button>
          </div>
        </Modal>

        <Modal trigger='click' centered open={openBlockModel} width={window?.innerWidth < 768 ? 300 : 400} footer={null} destroyOnClose onCancel={() => setOpenBlockModel(false)}>
          <header className='font-semibold text-base mb-2'>{`Block ${getBlockTypeLabel(blockValue?.type)}`}</header>
          <div className='mb-8'>
            {`Are you sure you want to Block this ${blockValue?.value}`}
            <span>{'?'}</span>
          </div>
          <div className='flex mt-4 modalButton'>
            <Button
              onClick={() => {
                setOpenBlockModel(false);
              }}
              block
              className='rounded-lg bg-plain'>
              Cancel
            </Button>
            <Button className='ml-4 DeleteBtn rounded-lg' block onClick={handleBlock} loading={isValueAdding}>
              Confirm
            </Button>
          </div>
        </Modal>

        <Modal trigger='click' open={openCaptureModal} className='capture-modal' width={window?.innerWidth < 768 ? 300 : 400} footer={null} destroyOnClose onCancel={handleCaptureModalOpen}>
          <div className='mobileVersion'>
            <div className='font-semibold text-base'>Capture Payment</div>
            <div className='mb-6'>
              <div className='mt-4 mb-4'>
                <div className=' order-solid customSelect' style={{ marginTop: '5px' }}>
                  <p className='font-medium mb-1'>Capture Type</p>
                  <Select defaultValue={'Full Amount'} handleChange={handleCaptureType} optionsValue={captureOption} style={{ width: '100%', borderRadius: '8px' }} />
                </div>
              </div>
              {isPartialCapture ? (
                <div>
                  <p className='font-medium mb-1' style={{ margin: '12px 0px 3px 0px' }}>
                    Amount
                  </p>
                  <Input
                    type='number'
                    value={captureAmount !== 0 ? captureAmount : ''}
                    onChange={(e) => handleCaptureAmount(e?.target?.value)}
                    min={0}
                    placeholder={'Enter Capture Amount'}
                    style={{ height: '40px' }}
                  />
                </div>
              ) : null}
            </div>
          </div>
          <div className='flex mt-4 modalButton'>
            <Button
              onClick={() => {
                setOpenCaptureModal(false);
              }}
              block
              className='rounded-lg bg-plain'>
              Cancel
            </Button>
            <Button className='ml-4 primaryBtn rounded-lg' disabled={isPartialCapture && (captureAmount ? false : true)} block onClick={capturePayment} loading={loading}>
              Capture Payment
            </Button>
          </div>
        </Modal>
      </div>

      <div className={isLoading || record ? 'footer' : ''}>
        {isLoading ? (
          <div style={{ display: 'flex', justifyContent: 'right', gap: '20px' }}>
            <Skeleton.Input active style={{ marginTop: '0' }} className='first-button' />
            <Skeleton.Input active style={{ marginTop: '0' }} className='second-button' />
          </div>
        ) : (
          record && (
            <div className='btnContainer' style={{ marginTop: '0' }}>
              {refundData?.status === 'AUTHORIZED_RISK_DECLINED' && checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN]) && (
                <>
                  <Button className='secondary-btn ml-4' onClick={() => handleRiskTransaction('approve')} block loading={riskApproveLoading}>
                    Approve
                  </Button>
                  <Button className='secondary-btn ml-4' onClick={() => handleRiskTransaction('reject')} block loading={riskCancelLoading}>
                    Reject
                  </Button>
                </>
              )}
              {(refundData?.status === 'FAILED' || refundData?.status === 'TIMEOUT' || refundData?.status === 'CANCELLED') &&
                refundData?.orderType === 'shopify' &&
                checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN]) && (
                  <Button className='secondary-btn ml-4' block onClick={() => replicateOrder(refundData?.orderId, refundData?.store_id)} loading={loading}>
                    Reorder
                  </Button>
                )}
              {refundData?.status === 'AUTHORIZED' && checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_REFUND]) && isFeatureEnabled(store, 'Capture/Void') && (
                <>
                  <Button
                    className='secondary-btn ml-4'
                    onClick={() => {
                      setOpenVoidModal(true);
                    }}>
                    Void Payment
                  </Button>
                  <Button
                    className='secondary-btn ml-4'
                    onClick={() => {
                      setOpenCaptureModal(true);
                      setIsPartialCapture(false);
                    }}>
                    Capture Payment
                  </Button>
                </>
              )}
              {(refundData?.status === 'CAPTURED' || refundData?.status === 'PARTIALLY_CAPTURED' || refundData?.status === 'PARTIALLY_REFUNDED') &&
                refundData?.refundAccess &&
                checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_REFUND]) &&
                refundData?.orderType !== 'shopify-public-app' &&
                refundData?.orderType !== 'shopify-cc-app' &&
                refundData?.orderType !== 'shopify-alternate-app' &&
                refundData?.gatewayType !== 'baadmay' &&
                refundData?.payment_method !== 'RTP' &&
                !(refundData?.payment_method === 'DQR' && refundData?.gatewayType === 'bank-alfalah') &&
                isFeatureEnabled(store, 'Refund') && (
                  <Button className='secondary-btn ml-4' onClick={() => setOpen(true)}>
                    Refund Amount
                  </Button>
                )}
              {refundData?.status !== 'REFUNDED' &&
                refundData?.status !== 'PARTIALLY_REFUNDED' &&
                checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN, USER_ROLES.XPAY_DEVELOPER]) && (
                  <Button className='primary-btn primaryBtn ml-4 mr-4' block onClick={handleWebhookTrigger} loading={triggerWebhook}>
                    Trigger Webhook
                  </Button>
                )}
            </div>
          )
        )}
      </div>
    </div>
  );
};
export default ViewTransection;
